export default function getDevicePixelRatio() {
  return Math.abs(window.devicePixelRatio)
}
